
<template>
  <div class="products-grid">
    <v-row no-gutters  class="pb-0">
      <v-col cols="8">
        Toimituskulut:
        <span >
          <v-text-field
            class="maxw-50"
            style="padding-left:5px; display:inline-block; font-size:16px !important;"
            v-model="deliveryCharges"
            
            suffix="€"
          ></v-text-field>
          
        </span>
        
      </v-col>
      <v-spacer></v-spacer>
      <v-btn color="#000000" @click="addProductToPromotion" dark class="add-button avecor-button-global">Lisää tuote</v-btn>
    </v-row>
    <v-container v-for="(product, index) in products" class="pa-4 my-2" style="background:#eee; border:1px dotted #ccc; position:relative" :key="'promotion-product-'+index">
        <div style="position:absolute; top:10px; left:10px;">
          <div>Tuote {{index+1}}</div>
        </div>
        <div style="position:absolute; top:10px; right:10px;">
          <v-icon small @click="deleteProductFromPromotion(index)">far fa-trash-alt</v-icon>
        </div>
        <v-row no-gutters class="pt-4">
          <v-col cols="12" sm="4" class="pr-3">
            <v-autocomplete
              v-model="product.productVariationId"
              :items="getCatalogProductsAndVariations"
              label="Etsi tuotteita"
              item-text="text"
              item-value="value"
              class="red-caret" 
              :error-messages="productsErrors[index].productVariationId"
              @change="productFieldChanged(index)"
              chips
            >
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  close
                  small
                  class="chip--select-multi"
                  @click:close="removeProductSelection(index)"
                >
                  {{ data.item.text.substr(0,20) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" class="pr-3">
            <v-text-field
              v-model="product.productName"
              label="Tuotenimi*"
              :error-messages="productsErrors[index].productName"
              @blur="fieldUpdated('productName', index)"
              @keyup="fieldUpdated('productName', index)"
              :disabled="true"
              />
          </v-col>
          <!-- :disabled="product.productVariationId !== ''" -->
          <v-col cols="12" sm="2" class="pr-3">
            <v-text-field
              v-model="product.sku"
              label="Tuotekoodi*"
              :error-messages="productsErrors[index].sku"
              @blur="fieldUpdated('sku', index)"
              @keyup="fieldUpdated('sku', index)"
              :disabled="true"
              />
          </v-col>
          <v-col cols="12" sm="1" class="pr-3">
            <v-text-field
              v-model="product.color"
              label="Väri"
              :error-messages="productsErrors[index].color"
              @blur="fieldUpdated('color', index)"
              @keyup="fieldUpdated('color', index)"
              :disabled="true"
              />
          </v-col>
          <v-col xs12 sm1 pr-3>
            <v-text-field
              v-model="product.size"
              label="Koko"
              @blur="fieldUpdated('size', index)"
              @keyup="fieldUpdated('size', index)"
              :disabled="true"
              />
          </v-col>
          <v-col xs12 sm2 pr-3>
            <v-autocomplete
              v-model="product.packageType"
              label="Pakkaustyyppi*"
              :items="getPackageTypes"
              :error-messages="productsErrors[index].packageType"
              @blur="fieldUpdated('packageType', index)"
              @keyup="fieldUpdated('packageType', index)"
              item-text="fi"
              item-value="id"
              :disabled="true"
              />
          </v-col>
        </v-row>  
        <v-row no-gutters>
          <v-col cols="4" v-if="product.productVariationId !== ''">
            <div class="text-left" style="font-size:12px; width:100%">
              <span>Valitse 1 kuva</span>
              <span style="padding-left:10px"><v-btn color="" @click="setFile({id:'',url:''},index,1)" x-small light style="border:1px solid #000000" >Poista</v-btn></span>
            </div>
            <div class="text-left" style="font-size:10px; font-style:italic; width:100%;">
              <v-radio-group v-model="product.imageSize" label="Koko" row>
                <v-radio label="L" value="L"></v-radio>
                <v-radio label="M" value="M"></v-radio>
                <v-radio label="S" value="S"></v-radio>
                <!-- <v-radio label="XS" value="XS"></v-radio> -->
              </v-radio-group>
            </div>
            <MediaGrid colsPerItem="3" @selectedFile="(file) => setFile(file,index,1)" itemClick="select" :actions="[]" context="promotion" :types="['productImage','draft']" :product="productCatalog[productVariations[product.productVariationId].productId]" :productVariation="productVariations[product.productVariationId]" ></MediaGrid>
          </v-col>
          <v-col cols="4" v-if="product.productVariationId !== ''">
            <div class="text-left" style="font-size:12px; width:100%">
              <span>Valitse 2 kuva</span>
              <span style="padding-left:10px"><v-btn color="" @click="setFile({id:'',url:''},index,2)" x-small light style="border:1px solid #000000" >Poista</v-btn></span>
            </div>
            <div class="text-left" style="font-size:10px; font-style:italic; width:100%;">
              <v-radio-group v-model="product.image2Size" label="Koko" row>
                <v-radio label="L" value="L"></v-radio>
                <v-radio label="M" value="M"></v-radio>
                <v-radio label="S" value="S"></v-radio>
                <!-- <v-radio label="XS" value="XS"></v-radio> -->
              </v-radio-group>
            </div>
            <MediaGrid colsPerItem="3" @selectedFile="(file) => setFile(file,index,2)" itemClick="select" :actions="[]" context="promotion" :types="['productImage','draft']" :product="productCatalog[productVariations[product.productVariationId].productId]" :productVariation="productVariations[product.productVariationId]" ></MediaGrid>
          </v-col>
          <v-col cols="4" v-if="product.productVariationId !== ''">
            <div class="text-left" style="font-size:12px; width:100%">
              <span>Valitse 3 kuva</span>
              <span style="padding-left:10px"><v-btn color="" @click="setFile({id:'',url:''},index,3)" x-small light style="border:1px solid #000000" >Poista</v-btn></span>
            </div>
            <div class="text-left" style="font-size:10px; font-style:italic; width:100%;">
              <v-radio-group v-model="product.image3Size" label="Koko" row>
                <v-radio label="L" value="L"></v-radio>
                <v-radio label="M" value="M"></v-radio>
                <v-radio label="S" value="S"></v-radio>
                <!-- <v-radio label="XS" value="XS"></v-radio> -->
              </v-radio-group>
            </div>
            
            <MediaGrid colsPerItem="3" @selectedFile="(file) => setFile(file,index,3)" itemClick="select" :actions="[]" context="promotion" :types="['productImage','draft']" :product="productCatalog[productVariations[product.productVariationId].productId]" :productVariation="productVariations[product.productVariationId]" ></MediaGrid>
          </v-col>
          <v-col cols="4" v-if="product.productVariationId !== '' && location !== 'pdfPromotion'">
            <div class="text-left" style="font-size:12px; width:100%">
              <span>Valitse 4 kuva</span>
              <span style="padding-left:10px"><v-btn color="" @click="setFile({id:'',url:''},index,4)" x-small light style="border:1px solid #000000" >Poista</v-btn></span>
            </div>
            <div class="text-left" style="font-size:10px; font-style:italic; width:100%;">
              <v-radio-group v-model="product.image4Size" label="Koko" row>
                <v-radio label="L" value="L"></v-radio>
                <v-radio label="M" value="M"></v-radio>
                <v-radio label="S" value="S"></v-radio>
                <!-- <v-radio label="XS" value="XS"></v-radio> -->
              </v-radio-group>
            </div>
            
            <MediaGrid colsPerItem="3" @selectedFile="(file) => setFile(file,index,4)" itemClick="select" :actions="[]" context="promotion" :types="['productImage','draft']" :product="productCatalog[productVariations[product.productVariationId].productId]" :productVariation="productVariations[product.productVariationId]" ></MediaGrid>
          </v-col>
          <v-col cols="4" v-if="product.productVariationId !== '' && location !== 'pdfPromotion'">
            <div class="text-left" style="font-size:12px; width:100%">
              <span>Valitse 5 kuva</span>
              <span style="padding-left:10px"><v-btn color="" @click="setFile({id:'',url:''},index,5)" x-small light style="border:1px solid #000000" >Poista</v-btn></span>
            </div>
            <div class="text-left" style="font-size:10px; font-style:italic; width:100%;">
              <v-radio-group v-model="product.image5Size" label="Koko" row>
                <v-radio label="L" value="L"></v-radio>
                <v-radio label="M" value="M"></v-radio>
                <v-radio label="S" value="S"></v-radio>
                <!-- <v-radio label="XS" value="XS"></v-radio> -->
              </v-radio-group>
            </div>
            
            <MediaGrid colsPerItem="3" @selectedFile="(file) => setFile(file,index,5)" itemClick="select" :actions="[]" context="promotion" :types="['productImage','draft']" :product="productCatalog[productVariations[product.productVariationId].productId]" :productVariation="productVariations[product.productVariationId]" ></MediaGrid>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pl-4" cols="6" v-if="product.productVariationId !== '' && product.productVariationId !== ''">
            <span class="text-center" style="font-size:12px">Lataa tuotekuva (jpeg)</span>
             <div style="height:50px; max-height:50px;" />
             <MediaUpload type="productImage" :productVariationId="product.productVariationId" :productId="product.productId" />
          </v-col>
          <v-col class="pl-4" cols="6" v-if="product.productVariationId !== '' && product.productVariationId !== ''">
            <span class="text-center" style="font-size:12px">Lataa vedoskuva (jpeg)</span>
            <v-autocomplete
              style="height:50px; max-height:50px;"
              v-model="selectedCompanyIdForDraft"
              :items="getCompanies"
              label="Mihin yritykseen vedos liittyy?"
              placeholder=" "
              item-text="text"
              item-value="value"
              class="hide-field-details"
              chips
            >
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  close
                  small
                  solo
                  class="chip--select-multi"
                >
                  {{ data.item.text.substr(0,20) }}
                </v-chip>
              </template>
            </v-autocomplete>
            <MediaUpload type="draft" :companyId="selectedCompanyIdForDraft" :productId="product.productId" :productVariationId="product.productVariationId" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="3" class="pr-3">
            <v-textarea
              label="Tuotenimi (vapaa tekstikenttä)"
              :auto-grow="autogrow"
              :value="product.customerProductName"
              @change="v => product.customerProductName = v"
              :error-messages="productsErrors[index].customerProductName"
              rows=1
              />
          </v-col>
          <v-col cols="12" sm="9" class="pr-3">
            <v-textarea
              label="Tuotekuvaus (vapaa tekstikenttä)"
              :auto-grow="autogrow"
              :value="product.customerProductDescription"
              @change="v => product.customerProductDescription = v"
              rows=1
              />
          </v-col>
        </v-row>
        <v-row no-gutters >
          <v-col cols="12" class="pr-3" offset="11"> 
            <v-icon class="avecor-table-actions" :size="16" @click="addPriceOfferToProduct(index)">far fa-plus-square</v-icon>
          </v-col>
        </v-row>
        <v-row no-gutters v-for="(offer, offerIndex) in product.offers" :key="'promotion-product-'+index+'-'+offerIndex">
          <v-col sm="3" class="pr-3">
            <v-text-field
              label="Määrä*"
              v-model="offer.quantity"
              @blur="fieldUpdated('quantity', index, offerIndex)"
              @keyup="fieldUpdated('quantity', index, offerIndex)"
              dense
              />
          </v-col>
          <v-col sm="3" class="pr-3">
            <v-text-field
              label="á hinta*"
              v-model="offer.unitPrice"
              @blur="fieldUpdated('unitPrice', index, offerIndex)"
              @keyup="fieldUpdated('unitPrice', index, offerIndex)"
              dense
              />
          </v-col>
          <v-col sm="3" class="pr-3">
            <v-text-field
              label="Merkkausten á hinta"
              v-model="offer.unitPrintPrice"
              @keyup="fieldUpdated('unitPrintPrice', index, offerIndex)"
              dense
              />
          </v-col>
          <v-col sm="2" class="pr-3">
            <v-text-field
              label="Aloituskulut"
              v-model="offer.startingCosts"
              @keyup="fieldUpdated('startingCosts', index, offerIndex)"
              dense
              />
          </v-col>
          <!-- <v-col sm="2" class="pr-3">
            <v-text-field
              label="Postikulut"
              v-model="offer.deliveryCharges"
              @keyup="fieldUpdated('deliveryCharges', index, offerIndex)"
              dense
              />
          </v-col> -->
          <v-col sm="1" class="pl-3">
            <v-icon size=14 style="height:100%" @click="deletePriceOfferFromProduct(offerIndex, index)">far fa-trash-alt</v-icon>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="location && location === 'pdfPromotion'">
          <v-col sm="12" class="pr-3">
            <v-textarea
              label="Lisäinfo hinnoista (vapaa tekstikenttä)"
              :auto-grow="autogrow"
              v-model="product.productNoticeText"
              rows=1
              />
          </v-col>
        </v-row>
        
        
    </v-container>
    <v-row no-gutters  class="pb-2 pt-2">
      <v-col cols="12" class="text-right">
        <v-btn color="#000000" @click="addProductToPromotion" dark class="add-button avecor-button-global">Lisää tuote</v-btn>
      </v-col>
    </v-row>
    <!-- <v-snackbar v-model="settings.snack" :timeout="3000" :color="settings.snackColor">
      {{ settings.snackText }}
      <v-btn flat @click="settings.snack = false">Close</v-btn>
    </v-snackbar> -->
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import shared from './../../shared'
export default {
    props:['location'],
    created(){
      this.createVariationName = shared.createVariationName
    },
    data: () => ({
      selectedCompanyIdForDraft: "",
      dialog: false,
      table: null,
      autogrow: true,
      headers: [
        //{ text: '#', value: 'number', align: 'left',},
        { text: 'Actions ', value: 'name', align: 'left', sortable: false },
        //{ text: 'Tuotenro', value: 'productId', align: 'left', sortable: false},
        //{ text: 'Tuotenimi', value: 'productId', align: 'left', sortable: false},
        { text: 'Valitse tuote', value: 'productVariationId', align: 'left', sortable: false},
        { text: 'Tuotenimi', value: 'productName', align: 'left', sortable: false},
        { text: 'Pakkaustyyppi', value: 'packageType', align: 'left', sortable: false},
        { text: 'Asiakkaalle näkyvä nimi', value: 'product', align: 'left', sortable: false},
        { text: 'Määrä', value: 'quantity', align: 'left', sortable: false},
        { text: 'á hinta', value: 'unitPrice', align: 'left', sortable: false},
        
        { text: 'Mallikappaleet', value: 'numberOfSamples', align: 'left', sortable: false},
        { text: 'Merkkaus ', value: 'print', align: 'left', sortable: false },
        { text: 'Merkkauksen määrä', value: 'printQuantity', align: 'left', sortable: false},
        { text: 'Merkkauksen á hinta', value: 'unitPrintPrice', align: 'left', sortable: false},
        { text: 'Merkkauskulun lisätiedot', value: 'printCostComments', align: 'left', sortable: false},
        { text: 'Asemointien määrä*', value: 'quantity', align: 'left', sortable: false},
        { text: 'Asemoinnin á hinta*', value: 'unitPrice', align: 'left', sortable: false},
        { text: 'Yhteensä', value: 'sum', align: 'left', sortable: false},
        { text: 'Merkkausväri ', value: 'printColor', align: 'left', sortable: false },
        { text: 'Merkkauskohta ', value: 'printLocation', align: 'left', sortable: false },
        { text: 'Mitä merkataan? ', value: 'printContent', align: 'left', sortable: false },
        { text: 'Viimeistään asiakkaalla ', value: 'latestToCustomer', align: 'left', sortable: false },
        { text: 'Merkkauksen lisätiedot ', value: 'printComments', align: 'left', sortable: false }
      ],
      editedIndex: -1,
        
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10),
    }),
    mounted() {
      if(this.products.length == 0)
        this.addProductToPromotion()
      //
      const table = this.$refs.table
    },
    computed: {
      getTotal: {
        get: function () {
          return (
            Number(this.products.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.unitPrice * currValue.quantity) 
            },0))
            + Number(this.products.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.unitPrintPrice * currValue.printQuantity) 
            },0)) 
            + Number(this.products.reduce((acc, currValue, currIndex, array) => { 
              return acc + (currValue.pricePerPositioning * currValue.numberOfPositionings) 
            },0))
              + Number(this.deliveryCharges)
            ).toFixed(2)
        },
        // setter
        set: function (newValue) {
          
        }
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      areTherePrintProducts(){
        var numberOfPrintProducts = Number(this.products.reduce((acc, currValue, currIndex, array) => { 
            return acc + currValue.print ? 1 : 0
          },0))
        if (numberOfPrintProducts > 0) return true
        return false
      },
      getGenders(){
        var genders = this.settings.genders
        return Object.keys(this.settings.genders).reduce(function(result, key) {
          result.push({...genders[key]});
          return result;
        }, []);
      },
      getPackageTypes(){
        var packageTypes = this.settings.packageTypes
        return Object.keys(this.settings.packageTypes).reduce(function(result, key) {
          result.push({...packageTypes[key]});
          return result;
        }, []);
      },
      
      formTitle () {
        return this.editedIndex === -1 ? 'Lisää tuote' : 'Muokkaa tuotetta'
        
      },
      getCatalogProducts(){
        var products = this.productCatalog
        var catalogProducts = []
        Object.keys(this.productCatalog).map(function(key, index) {
          var p = products[key]
          if(!p.archived) catalogProducts.push({text: p.name.fi, value: p.id})
          catalogProducts.push({text: p.name.fi, value: p.id})
          return ""
        })
        return catalogProducts
      },
      getCatalogProductsAndVariations(){
        var products = this.productCatalog
        var productVariations = this.productVariations
        var t = this
        var catalogProducts = []
        Object.keys(productVariations).map(function(key, index) {
          var pv = productVariations[key]
          if(products[pv.productId] !== undefined) {
            if (products[pv.productId].archived === undefined || products[pv.productId].archived == false){
              catalogProducts.push({text: products[pv.productId].name.fi + " - " + t.createVariationName(pv), value: pv.id})
            }
          }
          return ""
        })
        return catalogProducts
      },
      
      ...mapFields({
        productCatalog:'product.products',
        companies:'company.companies',
        productVariations:'productVariation.productVariations',
        settings:"settings",
        samplesArray:"newPromotionDetails.samplesArray",
        deliveryCharges:"newPromotionDetails.deliveryCharges",
        positioningCharges:"newPromotionDetails.positioningCharges",
        
        clientEmail:"newPromotionDetails.clientEmail",
        orderedProductInvoiceStyles:"settings.orderedProductInvoiceStyles"
      }),
      ...mapMultiRowFields({
        products: "newPromotionDetails.products",
        productsErrors: "newPromotionDetails.productsErrors",
      })
    },
    methods: {
      getValue(v){
        console.log(v.target)
        //v => product.useSmallImage = v
      },
      setFile(file,index,imageNumber){
        if(imageNumber == 1){
          this.products[index].selectedFileId = file.id 
          this.products[index].selectedFileUrl = file.url
        }
        else if(imageNumber == 2){
          console.log("HERE")
          this.products[index].selected2FileId = file.id 
          this.products[index].selected2FileUrl = file.url
        }
        else if(imageNumber == 3){
          this.products[index].selected3FileId = file.id 
          this.products[index].selected3FileUrl = file.url
        }
        else if(imageNumber == 4){
          this.products[index].selected4FileId = file.id 
          this.products[index].selected4FileUrl = file.url
        }
        else if(imageNumber == 5){
          this.products[index].selected5FileId = file.id 
          this.products[index].selected5FileUrl = file.url
        }
      },
      removeProductSelection (index) {
        //this.productsOtherInfo[index].existingProductSelected = false
        this.products[index].productVariationId = ""
        this.products[index].productId = ""
        this.products[index].productName = ""
        this.products[index].sku = ""
        this.products[index].color = ""
        this.products[index].size = ""
        this.products[index].packageType = ""
        this.productsErrors[index].productVariationId = ""
        this.productsErrors[index].productId = ""
        this.productsErrors[index].productName = ""
        this.productsErrors[index].packageType = ""
        this.products[index].selectedImageUrls=[]
        this.products[index].selectedFileId=''
        this.products[index].selectedFileUrl=''
        this.products[index].selected2FileId=''
        this.products[index].selected2FileUrl=''
        this.products[index].selected3FileId=''
        this.products[index].selected3FileUrl=''
        this.products[index].selected4FileId=''
        this.products[index].selected4FileUrl=''
        this.products[index].selected5FileId=''
        this.products[index].selected5FileUrl=''
      },
      productFieldChanged(index) {
        console.log(index)
        if (this.products[index].productVariationId !== "") {
          var variationId = this.products[index].productVariationId
          var pv = this.productVariations[variationId]
          this.products[index].warehoused = pv.warehoused !== undefined ? pv.warehoused : false
          var p = this.productCatalog[pv.productId]
          this.products[index].productId = p.id
          this.products[index].productName = p.name.fi
          this.products[index].packageType = pv.packageType
          this.products[index].selectedImageUrls=[]
          this.products[index].selectedFileId=''
          this.products[index].selectedFileUrl=''
          this.products[index].selected2FileId=''
          this.products[index].selected2FileUrl=''
          this.products[index].selected3FileId=''
          this.products[index].selected3FileUrl=''
          this.products[index].selected4FileId=''
          this.products[index].selected4FileUrl=''
          this.products[index].selected5FileId=''
          this.products[index].selected5FileUrl=''
          var colorName = ""
          var colorCode = ""
          pv.colorCode && this.settings.colors[pv.colorCode] ? colorName = this.settings.colors[pv.colorCode].fi : ''
          pv.colorCode && this.settings.colors[pv.colorCode] ? colorCode = this.settings.colors[pv.colorCode].id : ''
          
          this.products[index].color = colorName
          this.products[index].sku = p.avecorSku ? p.avecorSku : ''
          this.products[index].sku += p.avecorSku && colorCode ? '-'+colorCode : ''
          this.products[index].size = pv.size ? pv.size : ""
          this.productsErrors[index].productId = ""
          this.productsErrors[index].productVariationId = ""
          this.productsErrors[index].productName = ""
          this.productsErrors[index].packageType = ""

          
        }
        else {
          console.log("HERE")
          //this.producstsOtherInfo[index].existingProductSelected = false
        }
      },
      
      fieldUpdated(field, pi, oi){
        if (field === "unitPrice" && this.products[pi].offers[oi].unitPrice.trim() !== "" && this.products[pi].offers[oi].unitPrice.includes(',')) {
          this.products[pi].offers[oi].unitPrice = this.products[pi].offers[oi].unitPrice.replace(",", ".")
        }
        else if (field === "unitPrintPrice" && this.products[pi].offers[oi].unitPrintPrice.trim() !== "" && this.products[pi].offers[oi].unitPrintPrice.includes(',')) {
          this.products[pi].offers[oi].unitPrintPrice = this.products[pi].offers[oi].unitPrintPrice.replace(",", ".")
        }
        else if (field === "deliveryCharges" && this.products[pi].offers[oi].deliveryCharges.trim() !== "" && this.products[pi].offers[oi].deliveryCharges.includes(',')) {
          this.products[pi].offers[oi].deliveryCharges = this.products[pi].offers[oi].deliveryCharges.replace(",", ".")
        }
        else if (field === "startingCosts" && this.products[pi].offers[oi].startingCosts.trim() !== "" && this.products[pi].offers[oi].startingCosts.includes(',')) {
          this.products[pi].offers[oi].startingCosts = this.products[pi].offers[oi].startingCosts.replace(",", ".")
        }
      },
      calculateTotal(item) {

        return Number((item.unitPrice * item.quantity)
          + (item.unitPrintPrice * item.printQuantity) 
          + (item.pricePerPositioning * item.numberOfPositionings))
        .toFixed(2)
      },
      getProductVariations(productId){
        var productVariations = this.productVariations
        var t = this
        var variations = [] 
        Object.keys(this.productVariations).forEach(function(key, index) {
          var p = productVariations[key]
          if (p.productId === productId) {variations.push({text: t.createVariationName(p), value: p.id})}
        })
        return variations
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
        
        //moment(date).format('MMMM Do YYYY, h:mm:ss a');
      },
      addProductToPromotion(){
        var promotionProductTemplate = {
          productId: '',
          productVariationId: '',
          customerProductName: '',
          customerProductDescription: '',
          productNoticeText: '',
          selectedImageUrls:[],
          selectedFileId:'',
          selectedFileUrl:'',
          selected2FileId:'',
          selected2FileUrl:'',
          selected3FileId:'',
          selected3FileUrl:'',
          selected4FileId:'',
          selected4FileUrl:'',
          selected5FileId:'',
          selected5FileUrl:'',
          imageSize:"L",
          image2Size:"L",
          image3Size:"L",
          image4Size:"L",
          image5Size:"L",
          productName:'',
          sku:'',
          quantity: '',
          color: '',
          size: '',
          numberOfSamples: 0,
          unitPrice: '',
          unitPrintPrice:'',
          printQuantity:'',
          printCostComments:'',
          packageType:'',
          numberOfPositionings: "0",
          pricePerPositioning:"0",
          print: false,
          printColor: "",
          printLocation: "",
          printContent: "",
          printComments: "",
          latestToCustomer: '',
          whenToInvoice:'',
          offers: [
            {
              unitPrice: '',
              quantity: '',
              unitPrintPrice:'',
              deliveryCharges:'',
              startingCosts:''
            }
          ]
        }
        var promotionProductTemplateError = {
          productId: '',
          productVariationId: '',
          customerProductName: '',
          productName:'',
          sku:'',
          packageType:'',
          quantity: '',
          color: '',
          size: '',
          numberOfSamples: '',
          unitPrice: '',
          unitPrintPrice: '',
          printQuantity: '',
          printCostComments:'',
          numberOfPositionings: '',
          pricePerPositioning:'',
          print: '',
          printColor: "",
          printLocation: "",
          printContent: "",
          printComments: "",
          latestToCustomer: '',
          whenToInvoice:'',
        }
        
        this.$store.dispatch('addProductToPromotion', {
          product:promotionProductTemplate, 
          productError:promotionProductTemplateError,
        })
      },
      addProductsToPromotion(productsA){
        var products = productsA
        /* console.log("NOT SORTED")
        console.log(products) */
        products = products.sort((a,b) =>{
          //console.log({aorder:a.order,border:b.order})
          if(a.order && b.order) return a.order - b.order
          else return 0
        })
        /* console.log("SORTED")
        console.log(products) */
        for(var i = 0; i < products.length; i++){
          var product = products[i]
          var pv = this.productVariations[product.productVariationId]
          var p = this.productCatalog[product.productId]
          //console.log(pv)
          if (pv && p && (pv.archived === undefined || !pv.archived) && (p.archived === undefined || !p.archived)){
            /* console.log(pv)  
            console.log(pv.archived)   */
            if(product.imageSize === undefined) product = {...product, imageSize:"L"}
            if(product.image2Size === undefined) product = {...product, image2Size:"L"}
            if(product.image3Size === undefined) product = {...product, image3Size:"L"}
            if(product.image4Size === undefined) product = {...product, image4Size:"L"}
            if(product.image5Size === undefined) product = {...product, image5Size:"L"}
            if(product.selected2FileId === undefined) product = {...product, selected2FileId:""}
            if(product.selected2FileUrl === undefined) product = {...product, selected2FileUrl:""}
            if(product.selected3FileId === undefined) product = {...product, selected3FileId:""}
            if(product.selected3FileUrl === undefined) product = {...product, selected3FileUrl:""}
            if(product.selected4FileId === undefined) product = {...product, selected4FileId:""}
            if(product.selected4FileUrl === undefined) product = {...product, selected4FileUrl:""}
            if(product.selected5FileId === undefined) product = {...product, selected5FileId:""}
            if(product.selected5FileUrl === undefined) product = {...product, selected5FileUrl:""}
            this.$store.dispatch('addProductToPromotion', {
              product, 
              productError:{...this.promotionProductTemplateError},
            })
          }
          else{
            /* console.log(pv)
            console.log(p)
            if(pv) console.log("ARCHIVED "  +  pv.archived) */
          }
          //product.productVariationId)
          //console.log(product)
        }
      },
      addPriceOfferToProduct(index){
        var offer = {
            unitPrice: '',
            quantity: '',
            unitPrintPrice:'',
            deliveryCharges:'',
            startingCosts:''
        }
        this.$store.dispatch('addPriceOfferToProduct', {productNumber:index, offer})
        console.log(this.products)
      },
      deletePriceOfferFromProduct(offerIndex, productIndex){
        console.log({offerIndex, productIndex})
        this.$store.dispatch('deletePriceOfferFromProduct', {productIndex, offerIndex})
      },
      deleteProductFromPromotion(index){
        //this.products = this.products.splice(index,1)
        console.log(index)
        console.log(this.products)
        this.$store.dispatch('deleteProductFromPromotion', {productNumber:index})
        console.log(this.products)
      },
      
      inlineSave (item) {
        var index = this.products.indexOf(item) 
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      positioningChargesSave (newCharge) {
        this.positioningCharges = newCharge
        this.settings.snack = true
        this.settings.snackColor = 'success'
        this.settings.snackText = 'Päivitetty'
      },
      deliveryChargesSave (newCharge) {
        //console.log(newCharge)
        this.deliveryCharges = newCharge
        
        this.settings.snack = true
        this.settings.snackColor = 'success'
        this.settings.snackText = 'Päivitetty'
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/NewPromotionProducts.vue